/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Addprospectsdescription3Inputs */

const en_coinvestments_addprospectsdescription3 = /** @type {(inputs: Coinvestments_Addprospectsdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After we have your list of approved prospects you'll be able to send outreach emails`)
};

/**
* | output |
* | --- |
* | "After we have your list of approved prospects you'll be able to send outreach emails" |
*
* @param {Coinvestments_Addprospectsdescription3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_addprospectsdescription3 = /** @type {((inputs?: Coinvestments_Addprospectsdescription3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Addprospectsdescription3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_addprospectsdescription3(inputs)
});
export { coinvestments_addprospectsdescription3 as "coInvestments_addProspectsDescription" }